export default "__VITE_ASSET__a624887e__"